import React from "react";
import { Bookmark, BookmarkCheck } from "lucide-react";

/**
 * Small bookmark toggle. Two variants:
 *   - "icon"   → 28px round icon-only (used on schedule rows)
 *   - "button" → pill with label (used in TalkModal)
 */
export default function BookmarkButton({
  sessionId,
  bookmarked,
  onToggle,
  busy = false,
  variant = "icon",
}) {
  const handle = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (busy) return;
    onToggle?.();
  };

  if (variant === "button") {
    const isOn = !!bookmarked;
    return (
      <button
        type="button"
        onClick={handle}
        disabled={busy}
        className={
          "inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full text-xs font-semibold transition-colors " +
          (isOn
            ? "bg-[#28BBE3]/15 text-[#28BBE3] ring-1 ring-[#28BBE3]/30 hover:bg-[#28BBE3]/25"
            : "bg-white/10 text-white hover:bg-white/20")
        }
        data-testid={`bookmark-modal-${sessionId}`}
        title={isOn ? "Remove from My playlist" : "Save to My playlist"}
        aria-pressed={isOn}
      >
        {isOn ? <BookmarkCheck size={14} strokeWidth={2.2} /> : <Bookmark size={14} strokeWidth={2.2} />}
        {isOn ? "Saved" : "Save for later"}
      </button>
    );
  }

  // Icon variant (default)
  const isOn = !!bookmarked;
  return (
    <button
      type="button"
      onClick={handle}
      disabled={busy}
      className={
        "h-8 w-8 rounded-full flex items-center justify-center transition-colors shrink-0 " +
        (isOn
          ? "text-[#28BBE3] hover:bg-[#28BBE3]/10"
          : "text-slate-400 hover:text-slate-700 hover:bg-slate-100")
      }
      data-testid={`bookmark-row-${sessionId}`}
      title={isOn ? "Remove from My playlist" : "Save to My playlist"}
      aria-label={isOn ? "Remove bookmark" : "Add bookmark"}
      aria-pressed={isOn}
    >
      {isOn ? <BookmarkCheck size={15} strokeWidth={2.2} /> : <Bookmark size={15} strokeWidth={2.2} />}
    </button>
  );
}
